// import React from 'react';

import moment from 'moment';

const currentDate = moment();

export const eosReportHelper = (props, recordingInfo) => {
  let eosReturnObject = {
    techChkBx: {
      check: false,
      disable: true,
    },
    resEosButton: {
      disable: true,
    },
    textStatus: 'Study Not Completed',
  };

  // For early terminate
  if (
    props.eventHistory.data &&
    props.eventHistory.data.length > 0 &&
    props.eventHistory.data[0].event == 'study_period_early_termination'
  ) {
    console.log('ready', props.eosReportStatus.data.status);

    // api status check eosReportStatus
    const disableFlag = true;

    eosReturnObject = {
      techChkBx: {
        check: false,
        disable: false,
      },
      resEosButton: {
        disable: disableFlag,
      },
    };
  }

  // The study duration has not ended.
  else if (
    !(props.eventHistory.data && props.eventHistory.data.length > 0) &&
    !moment(currentDate).isAfter(
      moment(
        moment(recordingInfo.patient.study_period_starts_at).format(
          'DD-MM-YYYY',
        ),
        'DD-MM-YYYY',
      ).add(recordingInfo.patient.study_duration_in_days, 'days'),
    )
  ) {
    eosReturnObject = {
      techChkBx: {
        check: false,
        disable: true,
      },
      resEosButton: {
        disable: true,
      },
      textStatus: 'Study Not Completed',
    };
  }
  //  The study duration has ended but tech not checked the check box event history empty
  else if (!(props.eventHistory.data && props.eventHistory.data.length > 0)) {
    eosReturnObject = {
      techChkBx: {
        check: false,
        disable: false,
      },
      resEosButton: {
        disable: true,
      },
      textStatus: 'No Report Send Information',
    };
  }

  // Report resent again check history event 'requested_eos_report_refresh'
  else if (
    props.eventHistory.data &&
    props.eventHistory.data.length > 0 &&
    props.eventHistory.data[0].event == 'requested_eos_report_refresh'
  ) {
    eosReturnObject = {
      techChkBx: {
        check: true,
        disable: true,
      },
      resEosButton: {
        disable: false,
      },
      textStatus: `Report Sent By Resend ${moment(
        new Date(props.eventHistory.data[0].created_at),
      ).format('MM/DD/YYYY hh:mm')} CT`,
    };
  }

  // Eos report e-sign Resend not allowed check history event 'signed'
  else if (
    props.eventHistory.data &&
    props.eventHistory.data.length > 0 &&
    props.eventHistory.data[0].event == 'eos_report_e-sign'
  ) {
    eosReturnObject = {
      techChkBx: {
        check: true,
        disable: true,
      },
      resEosButton: {
        disable: true,
      },
      textStatus: 'EOS Report has been E-signed. Resend Not Allowed',
    };
  }

  //  Report in process of generated  checkbox checked and check for the api call for eosReportStatus for the enable  ResendEosButton
  else if (
    props.eventHistory.data &&
    props.eventHistory.data.length > 0 &&
    props.eventHistory.data[0].event == 'checked_eos_completed_review'
  ) {
    console.log('ready', props.eosReportStatus.data.status);

    // api status check eosReportStatus
    let disableFlag = true;
    disableFlag = !(
      props.eosReportStatus &&
      props.eosReportStatus.data &&
      props.eosReportStatus &&
      props.eosReportStatus.data.status === 'ready'
    );

    eosReturnObject = {
      techChkBx: {
        check: true,
        disable: true,
      },
      resEosButton: {
        disable: disableFlag,
      },
      textStatus: `Report Requested by Tech Completed EOS  Review ${moment(
        new Date(props.eventHistory.data[0].created_at),
      ).format('MM/DD/YYYY hh:mm')} CT`,
    };
  }

  return eosReturnObject;
};



// WEBPACK FOOTER //
// ./src/views/components/CCTPatientHistory/util.js